import { rewriteUrl } from "@rewriters/url";
import { VortexClient } from "@client/index";
import { VortexUrlChangeEvent } from "@client/events";
import { VORTEXCLIENT } from "@/symbols";

export default function (client: VortexClient, _self: Self) {
	client.Proxy(
		["History.prototype.pushState", "History.prototype.replaceState"],
		{
			apply(ctx) {
				if (ctx.args[2] || ctx.args[2] === "")
					ctx.args[2] = rewriteUrl(ctx.args[2], client.meta);
				ctx.call();
				const {
					constructor: { constructor: Function },
				} = ctx.this;
				const callerGlobalThisProxied: Self = Function("return globalThis")();
				const callerClient = callerGlobalThisProxied[VORTEXCLIENT];

				if (callerGlobalThisProxied.name === client.meta.topFrameName) {
					const ev = new VortexUrlChangeEvent(callerClient.url.href);
					client.frame?.dispatchEvent(ev);
				}
			},
		}
	);
}
